// extracted by mini-css-extract-plugin
module.exports = {"banner":"personal_banner__3OSZ7","content":"personal_content__2udPw"};